import TimeAgo, { Formatter, Suffix, Unit } from "react-timeago";

export interface FuzzyDurationProps {
  /** The duration in milliseconds */
  duration: number;
}

/**
 * Renders a rounded, humanized string for a duration in milliseconds.
 */
export const FuzzyDuration: React.FC<FuzzyDurationProps> = ({ duration }) => {
  return <TimeAgo live={false} date={duration} now={() => 0} formatter={durationFormatter} />;
};

/**
 * A timeago formatter for durations, that returns the default string without the ' from now' suffix.
 *
 * For example: "2 years from now" -> "2 years"
 */
function durationFormatter(
  value: number,
  unit: Unit,
  suffix: Suffix,
  epochMilliseconds: number,
  nextFormatter: Formatter,
  now: () => number,
) {
  const defaultFormat = nextFormatter(value, unit, suffix, epochMilliseconds, () => "", now) as string;
  return defaultFormat.slice(0, " from now".length * -1);
}
